module.exports = __webpack_public_path__ + "static/media/SocialCollectionLandingPage.382f18a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SocialCollectionLandingPage.jpg
// module id = 748
// module chunks = 0